import { createReducer } from './create';

const initialState = {
    start_time: null,
    product: null,
    event_url: null,
    confirmed_package: null,
    confirmed_tickets: [],
    food_ticket: null,
    optional_hotel: window.cart_settings != null
        ? window.cart_settings.hotel_optional
        : window.NOJESRESOR_PRODUCT != null
            ? window.NOJESRESOR_PRODUCT.hotels.optional
            : false,
    without_hotel: window.cart_settings != null
        ? window.cart_settings.hotel_no
        : window.NOJESRESOR_PRODUCT != null
            ? window.NOJESRESOR_PRODUCT.hotels.without
            : false,
    confirmed_hotel: null,
    selected_hotel_range: 0,
    selected_hotel_nights: 0,
    selected_hotel_room_type: 0,
    confirmed_food: null,
    loading_cart: false,
    loading_empty_cart: false,

    create_cart_error: null,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: state => {
        return {...initialState, loading_empty_cart: state.loading_empty_cart};
    },
    ['APP/SOFT_CLEAR']: state => {
        return {...initialState, loading_empty_cart: state.loading_empty_cart};
    },
    ['CART/TIMEOUT']: state => {
        return {
            ...initialState,
            start_time: state.start_time,
        };
    },
    ['APP/CLEAR_EVENT']: state => {
        return {
            ...initialState,
            loading_empty_cart: state.loading_empty_cart,
        };
    },
    ['APP/GO_TO_STEP_1']: state => {
        return {
            ...state,
            start_time: null,
            product: null,
            event_url: null,
            confirmed_package: null,
            confirmed_tickets: [],
            food_ticket: null,
            confirmed_hotel: null,
            selected_hotel_range: 0,
            selected_hotel_nights: 0,
            selected_hotel_room_type: 0,
        };
    },
    ['APP/GO_TO_STEP_2']: state => {
        return {
            ...state,
            start_time: null,
            confirmed_hotel: null,
            selected_hotel_range: 0,
            selected_hotel_nights: 0,
            selected_hotel_room_type: 0,
        };
    },
    ['TICKETS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            product: NOJESRESOR_PRODUCT,
            event_url: `${document.location.origin}/${document.location.pathname}`,
            confirmed_package: payload.confirmed_package,
            confirmed_tickets: payload.confirmed_tickets,
            food_ticket: payload.confirmed_tickets[0].food_ticket,
            optional_hotel: NOJESRESOR_PRODUCT.hotels.optional,
            without_hotel: NOJESRESOR_PRODUCT.hotels.without,
            confirmed_hotel: null,
            selected_hotel_room_type: 0,
            confirmed_food: null,
            loading_cart: false,
        });
    },
    ['HOTELS/DESELECT']: state => {
        return Object.assign({}, state, {
            confirmed_hotel: null,
            selected_hotel_room_type: 0,
            loading_cart: false,
        });
    },
    ['HOTELS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_hotel: payload.confirmed_hotel,
            selected_hotel_range: payload.selected_hotel_range,
            selected_hotel_nights: payload.selected_hotel_nights,
            selected_hotel_room_type: payload.selected_hotel_room_type,
            loading_cart: false,
        });
    },
    ['FOOD/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_food: payload.food,
        });
    },
    ['CART/CLEAR']: state => {
        return Object.assign({}, state, {
            loading_empty_cart: true,
        });
    },
    ['CART/CREATE']: state => {
        return Object.assign({}, state, {
            loading_cart: true,
        });
    },
    ['CART/START_TIMER']: state => {
        return {...state, start_time: new Date().getTime()};
    },
    ['CART/CREATE_ERROR']: (state, payload) => {
        return Object.assign({}, state, {
            loading_cart: false,
            create_cart_error: {
                type: payload.type,
                message: payload.message,
            },
        });
    },
    ['CART/CLEAR_EMPTY_CART_OVERLAY']: state => {
        return Object.assign({}, state, {
            loading_empty_cart: false,
        });
    },
    ['CART/SEND_TO_WORDPRESS_ERROR_CLEAR']: state => {
        return Object.assign({}, state, {
            loading_cart: false,
            create_cart_error: null,
        });
    },
    ['CART/TOGGLE']: state => {
        return Object.assign({}, state, {
            is_toggled: !state.is_toggled,
        });
    },
    ['CART/CLOSE']: state => {
        return Object.assign({}, state, {
            is_toggled: false,
        });
    },
    ['CART/OPEN']: state => {
        return Object.assign({}, state, {
            is_toggled: true,
        });
    },
});
